import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ask-successfully',
  templateUrl: './ask-successfully.component.html',
  styleUrls: ['./ask-successfully.component.scss']
})
export class AskSuccessfullyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
